<div class="loading" *ngIf="show">
    <div class="loader"></div>
</div>